<template>
  <v-container class="margen_paginas pt-7" fluid>
    <div>
      <v-container v-if="dc ['id_empinq'] && dc ['id_empinq'].visibilidad != ''" class="mb-3" fluid>
        <v-row>
          <v-col cols="12" sm="6" md="3" v-for="(elemento, indice) in arrayMaximoPlazasPorZonaEmpresaInquilina" :key="indice">
            <v-card shaped elevation="6" style="margin: -10px -10px 0px -10px" color="#FFF8E1">
              <v-card-title>{{elemento.maxpla}} plazas</v-card-title>
              <v-card-subtitle>{{ dc ['id_zon'].dominio_valores [elemento.id_zon] }}</v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <TablaDatosAPI
        ref="displaempinq"
        :titulo="$t ('Distribución de plazas')"
        icono="mdi-plus-minus-variant"
        tabla="displaempinq"
        :campos="['id_empinq+', 'id_tippas+', 'id_zon+', 'maxpla+', 'asipla']"
        :campos-filtrables="['id_empinq', 'id_tippas', 'id_zon']"
        :objeto-definicion-campos="dc"
        :objeto-registro-formulario="rf"
        titulo-crud="distribución"
        permitir-anadir
        permitir-modificar
        permitir-eliminar
        :busqueda-rapida="this.$store.operador.atributosRol.includes ('gesope')"
        :evento-antes-abrir-formulario-datos="actualizarPlazasDisponibles"
      >
        <template v-slot:[`item.maxpla`]="{ item }">
            <span style="font-weight: 500">{{ item.maxpla }}</span>
             / {{ maximoPlazasZonaEmpresaInquilina (item.id_empinq, item.id_zon) }}
        </template>

        <template v-slot:default="{ definicionCampos, datosRegistro, esAccionEliminar }">
          <CampoFormularioDatos v-if="definicionCampos['id_empinq'].visibilidad == ''" nombre-campo="id_empinq" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
          <CampoFormularioDatos nombre-campo="id_tippas" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :funcionFiltradoItems="filtradoItemsTiposDePasesSegunEmpresaInquilina" />
          <CampoFormularioDatos nombre-campo="id_zon" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" @change="actualizarPlazasDisponibles" :funcionFiltradoItems="filtradoItemsZonasSegunTipoDePase" />
          <CampoFormularioDatos
            nombre-campo="maxpla" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" @change="change_maxpla"
            :hint="mensajePlazasDisponibles"
            :funcionValidacion="comprobacionNumeroPlazas"
          />
          <div style="height: 14px"></div>
          <CampoFormularioDatos nombre-campo="asipla" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" @change="change_asipla" />
        </template>

      </TablaDatosAPI>
    </div>
  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import CampoFormularioDatos from '@/components/CampoFormularioDatos.vue'

export default {
  components: {
    TablaDatosAPI,
    CampoFormularioDatos
  },
  data () {
    return {
      dc: {},
      rf: {},
      plazasDisponibles: 0
    }
  },
  computed: {
    mensajePlazasDisponibles () {
      return "Plazas disponibles: " + this.plazasDisponibles;
    },
    arrayMaximoPlazasPorZonaEmpresaInquilina () {
      return this.$tablasConsulta.arrayRegistros ('r_maxplazon_empinq');
    }
  },
  methods: {
    filtradoItemsTiposDePasesSegunEmpresaInquilina  (item, datosRegistro) {
      return this.$tablasConsulta.localizarRegistro ('r_tippas_empinq', { id_empinq: datosRegistro.id_empinq, id_tippas: item.value }) != null;
    },
    filtradoItemsZonasSegunTipoDePase (item, datosRegistro) {
      return this.$tablasConsulta.localizarRegistro ('r_zon_tippas', { id_tippas: datosRegistro.id_tippas, id_zon: item.value }) != null;
    },
    maximoPlazasZonaEmpresaInquilina (id_empinq, id_zon) {
      let registro = this.$tablasConsulta.localizarRegistro ('r_maxplazon_empinq', { id_empinq: id_empinq, id_zon: id_zon });
      if (registro)
        return registro.maxpla;
      else
        return '-';
    },
    actualizarPlazasDisponibles () {
      let registro_maxplazon_empinq = this.$tablasConsulta.localizarRegistro ('r_maxplazon_empinq', { id_empinq: this.rf ['id_empinq'], id_zon: this.rf ['id_zon'] } );
      if (registro_maxplazon_empinq)
        this.plazasDisponibles = parseInt (registro_maxplazon_empinq.maxpla);
      else
        this.plazasDisponibles = 0;
      if (this.plazasDisponibles < this.rf ['maxpla'])
        this.$set (this.rf, 'maxpla', null);
    },
    change_maxpla () {
      this.$set (this.rf, 'asipla', []);
    },
    change_asipla () {
      this.$set (this.rf, 'maxpla', this.rf['asipla'].length ? this.rf['asipla'].length : 0);
    },
    comprobacionNumeroPlazas (valor) {
      var er = /^[0-9]+$/;
      if (!valor)
        return "Requerido";
      else if (!er.test(valor))
        return "Valor incorrecto";
      else if (parseInt (valor) > this.plazasDisponibles)
        return `El valor no puede ser superior al nº de plazas disponibles (${this.plazasDisponibles})`;
      else
        return true;
    }
  },
  mounted() {
    this.tablaDatos = this.$refs ['displaempinq'];
    this.$tablasConsulta.actualizar();
  }
};
</script>

<style>
</style>